import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { updateAgentOfRecord } from 'api/operations/groupService';
import ModalDelegate from 'store/general/modalDelegate';
import { bpHistory } from 'global/bpHistory';
import { InboundLeadController } from 'store/pages/groups-dashboard/types';
import { getRootStoreInstance } from 'store/rootStore';

interface ShortGroupFormFields extends DefaultFormFields {
  groupName: FormControl<string>;
  agentOfRecordId: FormControl<string>;
}

//* For now TIN-based sponsors don't have access to E-store, hence they don't need TIN logic here. */
export class InboundLeadModalStore implements InboundLeadController {
  private _rootStore = getRootStoreInstance();
  private _groupId = '';
  private _isLoading = false;

  public formController: FormController<ShortGroupFormFields> = new FormController(
    {
      groupName: new FormControl<string>('', { optional: true }),
      agentOfRecordId: new FormControl<string>(''),
    },
    {
      onSubmit: this.saveAndRedirect.bind(this),
    },
  );

  public modalDelegate: ModalDelegate = new ModalDelegate();

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get agentsOfRecord(): OptionType[] {
    return this._rootStore.agentsStore.agentsOfRecord.map((agent) => {
      return { value: agent.id, label: agent.name };
    });
  }

  public setGroupData(id: string, name: string): void {
    this._groupId = id;
    this.formController.fields.groupName.value = name;
    this.modalDelegate.open();
  }

  public async saveAOR(): Promise<void> {
    this.setLoading(true);
    if (!this.formController.basicFieldsValidationsPassed) {
      throw new Error('Attempted to submit invalid form!');
    }
    const selectedAgent = this._rootStore.agentsStore.agentsOfRecord.find(
      (agent) => agent.id === this.formController.fields.agentOfRecordId.value,
    );
    await updateAgentOfRecord(this._groupId, selectedAgent?.id || '');
    runInAction(() => {
      this.setLoading(false);
      this.modalDelegate.close();
    });
  }

  public async saveAndRedirect(): Promise<void> {
    await this.saveAOR();
    bpHistory.push(`/group/${this._groupId}`);
  }

  public setLoading(status: boolean): void {
    this._isLoading = status;
  }

  constructor() {
    makeObservable<InboundLeadModalStore, '_isLoading' | '_groupId'>(this, {
      _isLoading: observable,
      _groupId: observable,
      formController: observable,
      modalDelegate: observable,
      isLoading: computed,
      agentsOfRecord: computed,
      saveAOR: action.bound,
      saveAndRedirect: action.bound,
      setGroupData: action.bound,
      setLoading: action.bound,
    });
  }
}
